import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import i18n, { DEFAULT_LANG, SUPPORTED_LANGS } from "../../../i18n";
import { useIpLanguage } from "../../../hooks/useIpLanguage";
import { useSelector } from "react-redux";

export function LanguageRedirector() {
  const location = useLocation();
  const navigate = useNavigate();
  const { isLoading } = useIpLanguage();
  const { language: langFromIp } = useSelector((state) => state.Region);

  const pathSegments = location.pathname.split("/").filter(Boolean);
  const langInUrl = pathSegments[0];

  useEffect(() => {
    if (isLoading) {
      return;
    }
    if (!SUPPORTED_LANGS.includes(langInUrl)) {
      const detectedLang = langFromIp || i18n.language || DEFAULT_LANG;
      const newPath = `/${detectedLang}${location.pathname}`;
      navigate(newPath + location.search, { replace: true });
    }
  }, [langInUrl, location, navigate, langFromIp, isLoading]);

  return null;
}
